// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deprecated-root[data-v-00dde83e]{width:100%;height:100vh;background:#fff}.deprecated-root .main[data-v-00dde83e]{width:100%}.deprecated-root .main p[data-v-00dde83e]{width:80%;margin:30vh auto 0;text-align:center;font-size:16px;color:#333}", ""]);
// Exports
module.exports = exports;
